import { JioTranslateInstance } from '@jiotranslate/core-beta';

export const DevTools = () => (jiotranslate: JioTranslateInstance) =>
  jiotranslate;
export * from './typedIndex';
export {
  PREFERRED_LANGUAGES_LOCAL_STORAGE_KEY,
  DEVTOOLS_ID,
} from './constants';
